module.exports = __webpack_public_path__ + "static/img/Spike.fb5ceae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Spike.png
// module id = DxQZ
// module chunks = 1